'use client';

import dynamic from 'next/dynamic';
import { LoginSkeleton } from './LoginSkeleton';

// Lazy load Login component - defers Material-UI and form validation logic
// until the component is actually needed (after page interactive)
export const DynamicLogin = dynamic(() => import('@repo/ui').then((mod) => ({ default: mod.Login })), {
  loading: () => <LoginSkeleton />,
  ssr: false, // Load only on client (not needed for meta tags)
}) as any; // Type assertion to avoid generic type issues with next/dynamic
